import { useContext } from 'react';
import SimpleBar from 'simplebar-react';

import { MenuItem } from '.';
import { Private_Routes } from '../../constants';
import MenuGroup from './MenuGroup';
import { AppContext } from '../../context/Provider';

export const AppBarMenu = () => {
    const { isSkinSmart } = useContext(AppContext);

    return (
        <div className='app-menu navbar-menu'>
            <div className='navbar-brand-box'>
                <a href='/' className='logo logo-dark'>
                    <span className='logo-sm'>
                        <img
                            src={`/assets/images/${
                                isSkinSmart ? 'logo-sm' : 'siesa-light'
                            }.png`}
                            alt=''
                            height='17'
                        />
                    </span>

                    <span className='logo-lg'>
                        <img
                            src={`/assets/images/${
                                isSkinSmart ? 'logo-light' : 'siesa-light'
                            }.png`}
                            alt=''
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                        />
                    </span>
                </a>
                <a href='/' className='logo logo-light'>
                    <span className='logo-sm'>
                        <img
                            src={`/assets/images/${
                                isSkinSmart ? 'logo-sm' : 'siesa-light'
                            }.png`}
                            alt=''
                            height='17'
                        />
                    </span>

                    <span className='logo-lg'>
                        <img
                            src={`/assets/images/${
                                isSkinSmart ? 'logo-light' : 'siesa-dark'
                            }.png`}
                            alt=''
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                        />
                    </span>
                </a>
            </div>

            <SimpleBar
                style={{
                    width: '100%',
                    maxHeight: 'calc(100vh)',
                    height: 'calc(100vh)',
                }}
            >
                <div className='container-fluid'>
                    <div id='two-column-menu'></div>
                    <ul className='navbar-nav' id='navbar-nav'>
                        <MenuGroup text={'Menu'} isOpen={true} key={'menu'}>
                            <MenuItem
                                text={'Dashboard'}
                                href={`${Private_Routes.HOME}`}
                                key={'dashboard'}
                            />
                            <MenuItem
                                text={'Empleados'}
                                href={`${Private_Routes.EMPLOYEE_PAGE}`}
                                key={'employees'}
                            />

                            <MenuItem
                                text={'Clientes'}
                                href={`${Private_Routes.CUSTOMER_PAGE}`}
                                key={'customers'}
                            />
                        </MenuGroup>
                        <MenuGroup text={'Gestión Proyectos'} isOpen={false}>
                            <MenuItem
                                text={'Proyectos'}
                                href={`${Private_Routes.PROJECT_PAGE}`}
                                key={'Proyectos'}
                            />
                            <MenuItem
                                text={'Estados de los Proyectos'}
                                href={`${Private_Routes.PROJECT_STATUS_PAGE}`}
                                key={'project-status'}
                            />
                            <MenuItem
                                text={'Configuración de Hitos'}
                                href={`${Private_Routes.PROJECT_MILESTONE_PAGE}`}
                                key={'project-status'}
                            />
                        </MenuGroup>
                    </ul>
                </div>
            </SimpleBar>
        </div>
    );
};
